import { IRootState } from '../../../store'
import { IImmobilizationOptionsState } from '../store/options.types'

export const getImmobilizationOptionsSelector = (state: IRootState): IImmobilizationOptionsState =>
  state.options.immobilizationOptions
